import { type RunHandle, type Runner, type RunRequest, startRun } from "@codeshare/runner-core";

export { PYODIDE_VERSION } from "./version";

/** Runs Python (CPython 3 on Pyodide) in a worker. The runtime downloads on first use. */
export const pythonRunner: Runner = {
  id: "python",
  name: "Python",
  tests: "test_*.py files: test_* functions with assert, Test* and unittest.TestCase classes",
  run(request: RunRequest, options: { timeoutMs?: number } = {}): RunHandle {
    return startRun({
      createWorker: () =>
        new Worker(new URL("./python.worker.ts", import.meta.url), { type: "module" }),
      request,
      ...options,
    });
  },
};
